import React from "react";

/**
 * @component ProjectTemplateAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ProjectTemplateAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ProjectTemplateAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ProjectTemplateAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M20 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2zm0-7a2 2 0 012 2v3h-2v-3H10v10h3v2h-3a2 2 0 01-2-2V10a2 2 0 012-2h10zM7 5h10a2 2 0 011.995 1.85L19 7H7v12a2 2 0 01-2-2V7a2 2 0 012-2zm7-3a2 2 0 011.995 1.85L16 4H4v12a2 2 0 01-2-2V4a2 2 0 012-2h10z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ProjectTemplateAddIcon.displayName = "ProjectTemplateAddIcon";
export default ProjectTemplateAddIcon;
